/* eslint-disable @typescript-eslint/no-misused-promises */
import Btn, { BtnModifier } from 'components/btn';
import FormTextfield, { TextfieldModifier } from 'components/form/textfield';
import { useTranslation } from 'react-i18next';
import Typeahead, { TypeaheadModifier, TypeaheadSuggestion } from 'components/form/typeahead';
import ValidationSectionSelectorComponent, { ValidationSelectionCount } from 'pages/validation/components/validationSectionSelector';
import CountHelper from 'pages/validation/components/countHelper';
import { ValidationSectionId } from 'models/validation';

interface ValidationTableFilterProps {
  isLoadingSuccess: boolean;

  isFetching: boolean;
  setIsFetching: (value: boolean) => void;  

  globalSearch: string | null;
  setCountFromResponse: (value: number | null, id: ValidationSectionId) => void;

  buttonSelection: ValidationSectionId;
  setButtonSelection: (value: ValidationSectionId) => void;

  searchCb: (searchTerm: string) => void;
  count: ValidationSelectionCount[];
}

export default function ValidationTableFilters(props: ValidationTableFilterProps) {
  const { isLoadingSuccess, isFetching, buttonSelection, setButtonSelection, searchCb, count, setIsFetching, setCountFromResponse, globalSearch } = props;
  const { t } = useTranslation();

  return (
    <div className="ct_tableFilter">
        <div className="ct_tableFilter-validation">
        {isLoadingSuccess && ( 
          <>
          <CountHelper 
              setIsFetching={setIsFetching}
              setCountFromResponse={setCountFromResponse} 
              globalSearch={globalSearch}
            />
            <ValidationSectionSelectorComponent 
              isFetching={isFetching}
              setButtonSelection={setButtonSelection}
              buttonSelection={buttonSelection}
              count={count}
            />
          </>
        )}
        </div>
    </div>
  );
}
